import { useTranslation } from "react-i18next";
import * as yup from "yup";

import { fileData, inputData } from "@/data";

const useReleaseVideoSchema = () => {
    const { t } = useTranslation();

    return yup.object({
        [inputData.names.isrc]: yup
            .string()
            .required(t("messages.inputMsgs.required"))
            .length(12, t("messages.inputMsgs.length", { length: 12 })),
        [inputData.names.track]: yup.string().required(t("messages.inputMsgs.required")),
        [inputData.names.type]: yup.string().required(t("messages.inputMsgs.required")),
        [fileData.names.video]: yup.mixed().required(t("messages.inputMsgs.required")),
    });
};

export default useReleaseVideoSchema;
